module.exports = __webpack_public_path__ + "img/5Eagles.a2ca840d.jpg";